'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getActions = exports.getFormHandlers = exports.formHandler = exports.getFormEvents = exports.formEvent = exports.onSubmit = exports.SUBMIT = exports.onInput = exports.onFocus = exports.FOCUS = exports.onDragLeave = exports.DRAG_LEAVE = exports.onDragEnter = exports.DRAG_ENTER = exports.onChange = exports.CHANGE = exports.onBlur = exports.BLUR = exports.getFieldEvents = exports.fieldEvent = exports.valid = exports.VALID = exports.saved = exports.SAVED = exports.saveProgress = exports.SAVED_PROGRESS = exports.save = exports.SAVE = exports.open = exports.OPEN = exports.meta = exports.META = exports.invalid = exports.INVALID = exports.error = exports.ERROR = exports.close = exports.CLOSE = exports.clearError = exports.CLEAR_ERROR = exports.clear = exports.CLEAR = undefined;

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _memoize2 = require('lodash/memoize');

var _memoize3 = _interopRequireDefault(_memoize2);

var _mapKeys2 = require('lodash/mapKeys');

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

var _flow2 = require('lodash/flow');

var _flow3 = _interopRequireDefault(_flow2);

exports.savedProgress = savedProgress;

var _capeRedux = require('cape-redux');

var _utils = require('./utils');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
} // Close the field. Reset all values to default.


var CLEAR = exports.CLEAR = 'field/CLEAR';
var clear = exports.clear = (0, _utils.createAction)(CLEAR, false); // Not sure when you would use this.

var CLEAR_ERROR = exports.CLEAR_ERROR = 'field/CLEAR_ERROR';
var clearError = exports.clearError = (0, _utils.createAction)(CLEAR_ERROR, false); // The field has been closed.

var CLOSE = exports.CLOSE = 'field/CLOSE';
var close = exports.close = (0, _utils.createAction)(CLOSE, false); // Async error result. Sync errors should be calculated in container. See derivedState().

var ERROR = exports.ERROR = 'field/ERROR';
var error = exports.error = (0, _utils.createAction)(ERROR);
var INVALID = exports.INVALID = 'field/INVALID';
var invalid = exports.invalid = (0, _utils.createAction)(INVALID); // Set metadata about the editing process. If you need a place to put extra information.

var META = exports.META = 'field/META';
var meta = exports.meta = (0, _utils.createAction)(META); // Almost always the first thing that is called.

var OPEN = exports.OPEN = 'field/OPEN';
var open = exports.open = (0, _utils.createAction)(OPEN); // Saving to server.

var SAVE = exports.SAVE = 'field/SAVE';
var save = exports.save = (0, _utils.createAction)(SAVE); // Record upload/save progress.

var SAVED_PROGRESS = exports.SAVED_PROGRESS = 'field/SAVED_PROGRESS';

function savedProgress(prefix, valueOrEvent) {
  var action = (0, _utils.createAction)(SAVED_PROGRESS);
  var progress = (0, _utils.getProgress)(valueOrEvent);
  return function (dispatch) {
    return progress % 5 === 0 && dispatch(action(prefix, progress)) || false;
  };
}

var saveProgress = exports.saveProgress = (0, _capeRedux.createAction)(SAVED_PROGRESS, (0, _flow3.default)((0, _nthArg3.default)(1), _utils.getProgress), _utils.getMeta); // Has been saved on server.

var SAVED = exports.SAVED = 'field/SAVED';
var saved = exports.saved = (0, _utils.createAction)(SAVED);
var VALID = exports.VALID = 'field/VALID';
var valid = exports.valid = (0, _utils.createAction)(VALID); // Redux-field events:

var fieldEvent = exports.fieldEvent = {
  clear: clear,
  clearError: clearError,
  close: close,
  error: error,
  invalid: invalid,
  meta: meta,
  open: open,
  save: save,
  saved: saved,
  savedProgress: savedProgress,
  valid: valid
};
var getFieldEvents = exports.getFieldEvents = (0, _utils.mapPartial)(fieldEvent); // FORM & FOCUS EVENTS

var BLUR = exports.BLUR = 'field/BLUR';
var onBlur = exports.onBlur = (0, _utils.createAction)(BLUR); // On every change of field value.

var CHANGE = exports.CHANGE = 'field/CHANGE';
var onChange = exports.onChange = (0, _utils.createAction)(CHANGE);
var DRAG_ENTER = exports.DRAG_ENTER = 'field/DRAG_ENTER';
var onDragEnter = exports.onDragEnter = (0, _utils.createAction)(DRAG_ENTER);
var DRAG_LEAVE = exports.DRAG_LEAVE = 'field/DRAG_LEAVE';
var onDragLeave = exports.onDragLeave = (0, _utils.createAction)(DRAG_LEAVE); // When a user clicks on a field to edit it.

var FOCUS = exports.FOCUS = 'field/FOCUS';
var onFocus = exports.onFocus = (0, _utils.createAction)(FOCUS); // Alias of onChange.

var onInput = exports.onInput = onChange; // Submit, close, save.

var SUBMIT = exports.SUBMIT = 'field/SUBMIT'; // @TODO Create timer to trigger error if doesn't submit.

var onSubmit = exports.onSubmit = (0, _utils.createAction)(SUBMIT); // Form and focus events:

var formEvent = exports.formEvent = {
  onBlur: onBlur,
  onChange: onChange,
  onFocus: onFocus,
  onInput: onInput,
  onSubmit: onSubmit
};
var getFormEvents = exports.getFormEvents = (0, _utils.mapPartial)(formEvent);
var formHandler = exports.formHandler = (0, _mapKeys3.default)(formEvent, function (val, key) {
  return key.replace('on', 'handle');
});
var getFormHandlers = exports.getFormHandlers = (0, _utils.mapPartial)(formHandler);
var getActions = exports.getActions = (0, _memoize3.default)(function (prefix) {
  return {
    fieldEvent: getFieldEvents(prefix),
    formEvent: getFormEvents(prefix),
    formHandler: getFormHandlers(prefix)
  };
}, function (prefix) {
  return prefix.toString();
});